{
  "alert.informative": "Informative",
  "alert.negative": "Negative",
  "alert.notice": "Notice",
  "alert.positive": "Positive",
  "chat.newMessage": "Jauns ziņojums",
  "chat.scrollToBottom": "Ritiniet uz leju",
  "messagefeedback.thumbDown": "Slikta atbilde",
  "messagefeedback.thumbUp": "Laba atbilde",
  "promptfield.aiDisclaimer": "Atbildes tiek ģenerētas, izmantojot mākslīgo intelektu, un tās var būt neprecīzas. Pārbaudiet pirms lietošanas.",
  "promptfield.aiUserGuidlines": "AI lietotāja vadlīnijas",
  "promptfield.attachments": "Pielikumi",
  "promptfield.insertButton": "Pievienot",
  "promptfield.label": "Uzvedne",
  "promptfield.placeholder": "Vai esat gatavs sākt? Uzdodiet jautājumu, dalieties pārdomās vai pievienojiet jaunu uzdevumu.",
  "promptfield.placeholder.small": "Ask anything",
  "promptfield.stopButton": "Apstājies",
  "promptfield.submitButton": "Sūtīt",
  "promptfield.uploading": "Augšupielāde",
  "responsestatus.loading": "Notiek ielāde",
  "responsestatus.processing": "Processing...",
  "voicebutton.startListening": "Sāciet ierakstīt",
  "voicebutton.stopListening": "Pārtraukt ierakstu",
  "attachmentlist.previousAttachments": "Show previous attachments",
  "attachmentlist.nextAttachments": "Show next attachments"
}
